import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articleContent';

export default function ArticleCardsSection() {
  return (
    <section id="articles" className="w-full px-4 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            In-Depth Basetao Guides & Resources
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            Explore our comprehensive collection of SEO-optimized guides covering everything from beginner basics to advanced power-user strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group flex flex-col rounded-xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer transition-all duration-300 hover:border-primary-300/50 hover:shadow-md"
            >
              <div className="relative w-full aspect-[8/5] overflow-hidden">
                <img
                  src={article.cardImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-white/90 backdrop-blur-sm text-foreground-800 text-xs font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-800 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4 line-clamp-2 flex-1">
                  {article.description}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400 pt-3 border-t border-background-200/70">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/basetao-spreadsheet-guide"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-white text-sm font-semibold transition-all duration-300 hover:bg-accent-600"
          >
            View All Guides
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}